import { render, staticRenderFns } from "./SessionManagement.vue?vue&type=template&id=5066cf88&scoped=true"
import script from "./SessionManagement.vue?vue&type=script&lang=js"
export * from "./SessionManagement.vue?vue&type=script&lang=js"
import style0 from "./SessionManagement.vue?vue&type=style&index=0&id=5066cf88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066cf88",
  null
  
)

export default component.exports